import { ActionTree } from 'vuex';
import { IBillingState } from './billing.types';
import { EBillingActions, EBillingMutations, IBillingPayload } from './billing.constants';
import { RootState } from '@/store/store';
import BillingService from '@/api/settings/services/settings.billing.service';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';
import { translate } from '@/helpers/translation.helper';
import bugsnagClient from '@lib-shared/bugsnag';

export const actions: ActionTree<IBillingState, RootState> = {
  async [EBillingActions.Update](
    { dispatch },
    { payload, entityId }: { payload: IBillingPayload; entityId: string }
  ) {
    try {
      await BillingService.update(payload, entityId);
    } catch (error) {
      if (bugsnagClient) {
        bugsnagClient.notify(error);
      }
      dispatch(EBillingActions.UpdateFailed);
    }
  },
  [EBillingActions.UpdateFailed]({ dispatch }) {
    dispatch(
      `${alertNamespace}/${EAlertAction.ShowDanger}`,
      translate('could-not-update-billing-info'),
      {
        root: true,
      }
    );
  },
  async [EBillingActions.Validate]({ dispatch, commit }) {
    try {
      commit(EBillingMutations.SetLoading, true);
      const error: string = await BillingService.validate();
      dispatch(EBillingActions.ValidateError, error);
    } catch (error) {
      if (bugsnagClient) {
        bugsnagClient.notify(error);
      }
      dispatch(EBillingActions.ValidateFailed);
    }
  },
  [EBillingActions.ValidateFailed]({ dispatch }) {
    dispatch(
      `${alertNamespace}/${EAlertAction.ShowDanger}`,
      translate('could-not-validate-billing-data'),
      {
        root: true,
      }
    );
  },
  [EBillingActions.ValidateError]({ commit }, error: string) {
    commit(EBillingMutations.SetLoading, false);
    commit(EBillingMutations.SetError, error);
  },
};
